import { useCallback, useState } from 'react';

import { Select } from '~components/generic/editor/Select/Select';
import styles from './EditComponents.module.css';

const simpleSelectItems = [
  'Neptunium',
  'Plutonium',
  'Americium',
  'Curium',
  'Berkelium',
  'Californium',
  'Einsteinium',
  'Fermium',
  'Mendelevium',
  'Nobelium',
  'Lawrencium',
  'Rutherfordium',
  'Dubnium',
  'Seaborgium',
  'Bohrium',
  'Hassium',
  'Meitnerium',
];

export const SelectSection = () => {
  const [value, setValue] = useState('Fermium');
  const handleOnChange = useCallback((value: string) => {
    console.log('handleOnChange: %s', value);
  }, []);

  return (
    <div className={styles.container}>
      <section>
        <h5>Select</h5>
        <div className={styles.component}>
          <Select items={simpleSelectItems} onChange={handleOnChange} />
        </div>
        <div className={styles.component}>
          <Select items={simpleSelectItems} selectedValue={value} onChange={value => setValue(value)} />
        </div>
        <div className={styles.component}>
          <Select items={simpleSelectItems} defaultValue="Dubnium" />
        </div>
      </section>
    </div>
  );
};
